import classes from './ChatWidget.module.scss'
import { ChatSavedCreditCard } from './types'

interface Props {
  cards: ChatSavedCreditCard[]
}

/**
 * Kayıtlı kredi kartları kartı (Hesabım > Kredi Kartlarım ekranının salt-okunur karşılığı):
 * banka + maskeli numara + kart sahibi + KVKK/onay durumu. Kart ekleme, silme ve aktiflik
 * değiştirme BİLEREK YOKTUR — bu bileşen yalnızca bilgi gösterir.
 * Kart numarası backend'de maskelenmiştir; burada hiçbir dönüşüm yapılmaz.
 */
export default function CreditCardsCard({ cards }: Props) {
  if (cards.length === 0) return null

  return (
    <div className={classes.creditCardList}>
      {cards.map((card, index) => (
        <div
          key={`${card.maskedNumber}-${index}`}
          className={`${classes.creditCardItem} ${card.active ? '' : classes.creditCardItemClosed}`}
        >
          <div className={classes.creditCardTop}>
            <span className={classes.creditCardBank}>{card.bankName || 'Banka bilgisi yok'}</span>
            {card.statusText && (
              <span
                className={`${classes.creditCardStatus} ${
                  card.statusText === 'Onaylandı'
                    ? classes.creditCardStatusApproved
                    : card.statusText === 'Reddedildi'
                      ? classes.creditCardStatusRejected
                      : classes.creditCardStatusPending
                }`}
              >
                {card.statusText}
              </span>
            )}
          </div>

          <div className={classes.creditCardNumber}>{card.maskedNumber}</div>
          {card.cardHolder && <div className={classes.creditCardHolder}>{card.cardHolder}</div>}

          <div className={classes.creditCardMeta}>
            <span className={card.kvkkApproved ? classes.creditCardKvkkOk : classes.creditCardKvkkNone}>
              {card.kvkkText}
            </span>
            {card.active && <span className={classes.creditCardFlag}>{card.enabled ? 'Aktif' : 'Pasif'}</span>}
          </div>

          {card.addedBy && <div className={classes.creditCardAddedBy}>Ekleyen: {card.addedBy}</div>}
          {card.usageNote && <div className={classes.creditCardNote}>{card.usageNote}</div>}
        </div>
      ))}
    </div>
  )
}
